module.exports = __webpack_public_path__ + "img/hotelFamily-2.a08f5dee.jpg";